import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import state from './state';
import { readonly } from 'vue';
import { IInlineSearchStore } from '@/interfaces/store.interface';
import { IInlineSearchState } from '@/interfaces/state.interface';


const store: IInlineSearchStore = {
	state: readonly(state) as IInlineSearchState,
	getters,
	mutations,
	actions,
};

export default store;